import React, { useState } from "react";
import { test } from "../../../../../Status";
import "./ProblemSet.css";
import Problem from "../../../../ProblemLayout/Problem";
import { WeeklyProblems } from "../../../../../Status";


const getCurrentWeeks = () => {
  const today = new Date();
  const day = today.getDate();

  if (day >= 1 && day <= 7) return [1];
  if (day >= 8 && day <= 14) return [1,2];
  if (day >= 15 && day <= 21) return [1, 2, 3];
  return [1, 2, 3, 4]; // After the 21st, all weeks are visible
};



const ProblemSet = () => {
  const [PassDue,setPassDue]=useState(false)
  const currentWeek=getCurrentWeeks()

  return (
    <div className="PRoblemSet">
      <div className="Submit-button">
        <button style={{ backgroundColor: "#60712F" }}>Submission Guide</button>
        {test.role === "Admin" ? (
          <button style={{ backgroundColor: "#6f0419" }}>Edit Problems</button>
        ) : (
          <button style={{ backgroundColor: "#6f0419" }}>
            Download Answer Sheet
          </button>
        )}
      </div>

      <div className="Weeks">
        <div className="Week">
          <h1>Weekly Problems : Week 1 </h1>
        </div>
        <div className="ProblemStatemts">
          {WeeklyProblems.filter((item) => item.Week === 1).map((el) =>
            el.Problems.map((problem) => <Problem problem={problem} PassDue={currentWeek.includes(2)? true : false} />)
          )}
        </div>

        <div className="Week">
          <h1>Weekly Problems : Week 2</h1>
        </div>
        <div className="ProblemStatemts">
          {currentWeek.includes(2)?
          (WeeklyProblems.filter((item) => item.Week === 2).map((el) =>
            el.Problems.map((problem) => <Problem problem={problem} PassDue={currentWeek.includes(3)? true : false} />)
          )): 
          (
            <div className='EmptyRepo'>
        <h5>* But nobody came. This problem set is intended to be posted on the 8th of this month.</h5>
        
      </div>
          )}
        </div>

        <div className="Week">
          <h1>Weekly Problems : Week 3</h1>
        </div>
        <div className="ProblemStatemts">
          {currentWeek.includes(3)?
          (WeeklyProblems.filter((item) => item.Week === 3).map((el) =>
            el.Problems.map((problem) => <Problem problem={problem}  PassDue={currentWeek.includes(4)? true : false}/>)
          )):
          (
            <div className='EmptyRepo'>
        <h5>* But nobody came. This problem set is intended to be posted on the 15th of this month.</h5>
        
      </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProblemSet;
